import { Phase } from '../core/context/phase/entity';

// TODO: We should distinguish between different types of phases: parents and childrens
export enum PhaseName {
    Definition = 'Definition',
    RiskScoping = 'Risk scoping',
    ThreatModeling = 'Threat modeling',
    RiskTreatment = 'Risk treatment',
    Reporting = 'Reporting',
    Details = 'Details',
    RiskLikelihood = 'Risk & likelihood',
    ProtectionGoals = 'Protection goals',
    TacticsAndTechniques = 'Tactics and techniques',
    Settings = 'Settings',
    ScopeOfTra = 'Scope of TRA',
    ScopingAssets = 'Scoping assets',
    RelationTypes = 'Relation types',
    ThreatPathAndVectors = 'Threat path and vectors',
    CreateTreatments = 'Create treatments',
}

export const phases: Phase[] = [
    new Phase({
        id: '1',
        name: PhaseName.Definition,
        nextPhaseId: '2',
        icon: 'target',
    }),
    new Phase({
        id: '2',
        name: PhaseName.RiskScoping,
        nextPhaseId: '3',
        icon: 'arrow_range',
    }),
    new Phase({
        id: '3',
        name: PhaseName.ThreatModeling,
        nextPhaseId: '4',
        icon: 'model_training',
    }),
    new Phase({
        id: '4',
        name: PhaseName.RiskTreatment,
        nextPhaseId: '5',
        icon: 'local_hospital',
    }),
    new Phase({ id: '5', name: PhaseName.Reporting, icon: 'article' }),
    new Phase({
        id: '6',
        name: PhaseName.Details,
        rootPhaseId: '1',
        nextPhaseId: '7',
    }),
    new Phase({
        id: '7',
        name: PhaseName.RiskLikelihood,
        rootPhaseId: '1',
        nextPhaseId: '8',
    }),
    new Phase({
        id: '8',
        name: PhaseName.ProtectionGoals,
        rootPhaseId: '1',
        nextPhaseId: '9',
    }),
    new Phase({
        id: '9',
        name: PhaseName.TacticsAndTechniques,
        rootPhaseId: '1',
        nextPhaseId: '10',
    }),
    new Phase({
        id: '10',
        name: PhaseName.Settings,
        rootPhaseId: '1',
        nextPhaseId: '11',
    }),
    new Phase({
        id: '11',
        name: PhaseName.ScopeOfTra,
        rootPhaseId: '2',
        nextPhaseId: '12',
    }),
    new Phase({
        id: '12',
        name: PhaseName.ScopingAssets,
        rootPhaseId: '2',
        nextPhaseId: '13',
    }),
    new Phase({
        id: '13',
        name: PhaseName.RelationTypes,
        rootPhaseId: '2',
        nextPhaseId: '14',
    }),
    new Phase({
        id: '14',
        name: PhaseName.ThreatPathAndVectors,
        rootPhaseId: '3',
        nextPhaseId: '15',
    }),
    new Phase({
        id: '15',
        name: PhaseName.CreateTreatments,
        rootPhaseId: '4',
        nextPhaseId: '16',
    }),
    new Phase({
        id: '16',
        name: PhaseName.Reporting,
        rootPhaseId: '5',
    }),
];
